export class LoaderAudio {
    #audioArrToLoad = [];
    get audioArrToLoad() {
        return this.#audioArrToLoad;
    }
    set audioArrToLoad(audioArr) {
        this.#audioArrToLoad = audioArr;
    }
    loadAllAudio = (callbackAddSound) => {
        this.#audioArrToLoad.forEach((sound) => {
            callbackAddSound(sound);
        });
    };
}
//# sourceMappingURL=LoaderAudio.js.map